import React, { useState, lazy } from 'react';
const MAIN_VARIANT_ID = '43361556889718';
const BUMP_REGISTRO_VARIANT_ID = '43378158534774';
const BUMP_INCLUSIVO_VARIANT_ID = '43378155192438';
const BUNDLE_FULL_VARIANT_ID = '43378159845494';
export function PricingSection() {
  const [bumps, setBumps] = useState({
    registro: false,
    inclusivo: false
  });
  const checkoutUrl = (() => {
    if (bumps.registro && bumps.inclusivo) {
      return `https://italia.edulabs.online/cart/${BUNDLE_FULL_VARIANT_ID}:1`;
    }
    if (bumps.registro) {
      return `https://italia.edulabs.online/cart/${BUMP_REGISTRO_VARIANT_ID}:1`;
    }
    if (bumps.inclusivo) {
      return `https://italia.edulabs.online/cart/${BUMP_INCLUSIVO_VARIANT_ID}:1`;
    }
    return `https://italia.edulabs.online/cart/${MAIN_VARIANT_ID}:1`;
  })();
  const bumpPrices = {
    registro: 9.9,
    inclusivo: 12.9
  };
  const totalPrice = 19 + (bumps.registro ? bumpPrices.registro : 0) + (bumps.inclusivo ? bumpPrices.inclusivo : 0);
  const totalPriceFormatted = totalPrice % 1 === 0 ? totalPrice.toString() : totalPrice.toFixed(2).replace('.', ',');
  const firePixel = () => {
    const w = window as any;
    if (w.fbq) {
      const addons: string[] = [];
      if (bumps.registro) addons.push('Registro');
      if (bumps.inclusivo) addons.push('Inclusivo');
      w.fbq('track', 'AddToCart', {
        content_name: 'Matematica Pronta Bundle' + (addons.length ? ` + ${addons.join(' + ')}` : ''),
        content_type: 'product',
        value: totalPrice,
        currency: 'EUR'
      });
    }
  };
  const toggleBump = (key: keyof typeof bumps) => {
    setBumps(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  // Dynamic CTA copy based on selected order bumps
  const ctaCopy = (() => {
    if (bumps.registro && bumps.inclusivo) {
      return {
        desktop: `🚀 SÌ! VOGLIO IL PACCHETTO ULTIMATE — € ${totalPriceFormatted}`,
        mobile: `🚀 VOGLIO L'ULTIMATE — € ${totalPriceFormatted}`
      };
    }
    if (bumps.registro) {
      return {
        desktop: `🚀 SÌ! VOGLIO IL KIT + REGISTRO — € ${totalPriceFormatted}`,
        mobile: `🚀 KIT + REGISTRO — € ${totalPriceFormatted}`
      };
    }
    if (bumps.inclusivo) {
      return {
        desktop: `🚀 SÌ! VOGLIO IL KIT + ARCHIVIO INCLUSIVO — € ${totalPriceFormatted}`,
        mobile: `🚀 KIT + INCLUSIVO — € ${totalPriceFormatted}`
      };
    }
    return {
      desktop: `🚀 SÌ! VOGLIO IL KIT COMPLETO — € ${totalPriceFormatted}`,
      mobile: `🚀 VOGLIO IL KIT — € ${totalPriceFormatted}`
    };
  })();
  return <section id="pricing" className="w-full bg-bg-dark py-12 sm:py-28 px-4 sm:px-6 relative overflow-hidden pt-[30px] pb-[30px]" data-id="element-295">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.08) 0%, transparent 70%)'
    }} data-id="element-296"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 70%)'
    }} data-id="element-297"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-298">
        <h2 className="text-2xl sm:text-6xl font-black text-text-main text-center mb-5 sm:mb-16 tracking-tight px-2" data-id="element-299">
          L'Offerta "Matematica Pronta"
        </h2>

        {/* Featured Card */}
        <div className="bg-bg-alt rounded-2xl sm:rounded-3xl border border-primary/50 shadow-[0_0_50px_rgba(59,130,246,0.15)] px-4 py-6 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-300">
          {/* Glowing Border Effect */}
          <div className="absolute inset-0 rounded-2xl sm:rounded-3xl border-2 border-transparent bg-gradient-to-b from-primary/50 to-transparent opacity-50 pointer-events-none" style={{
          maskImage: 'linear-gradient(to bottom, black, transparent)',
          WebkitMaskImage: 'linear-gradient(to bottom, black, transparent)'
        }} data-id="element-301"></div>

          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-secondary to-yellow-400 text-bg-dark font-black text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(245,158,11,0.5)] border border-white/20" data-id="element-302">
            ⭐ LA SCELTA PIÙ POPOLARE
          </div>

          <p className="text-xs sm:text-3xl font-black text-text-main text-center mt-2 sm:mt-4 mb-3 sm:mb-10 tracking-wide" data-id="element-303">
            VALORE TOTALE DEI CONTENUTI:
          </p>

          {/* Value list */}
          <div className="space-y-1.5 sm:space-y-5 mb-3 sm:mb-10 text-[13px] sm:text-xl" data-id="element-304">
            <div className="flex justify-between gap-2 text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-305">
              <span data-id="element-306">Percorso Didattico (5 Volumi 1ª-5ª)</span>
              <span className="text-text-sec line-through flex-shrink-0" data-id="element-307">
                € 97
              </span>
            </div>
            <div className="flex justify-between gap-2 text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-308">
              <span data-id="element-309">Registro Valutazione & Materiale LIM</span>
              <span className="text-text-sec line-through flex-shrink-0" data-id="element-310">
                € 57
              </span>
            </div>
            <div className="flex justify-between gap-2 text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-311">
              <span data-id="element-312">Manuali di Laboratorio e Logica</span>
              <span className="text-text-sec line-through flex-shrink-0" data-id="element-313">
                € 47
              </span>
            </div>
            <div className="flex justify-between gap-2 text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-314">
              <span data-id="element-315">6 Bonus Esclusivi</span>
              <span className="text-text-sec line-through flex-shrink-0" data-id="element-316">
                € 49
              </span>
            </div>

            <div className="flex justify-between gap-2 text-text-main font-black pt-1 sm:pt-4 text-sm sm:text-2xl" data-id="element-317">
              <span data-id="element-318">VALORE REALE:</span>
              <span className="text-badge-red line-through" data-id="element-319">€ 250</span>
            </div>
          </div>

          {/* Price reveal */}
          <div className="text-center mb-4 sm:mb-8 bg-gradient-to-b from-primary/5 to-transparent border border-white/10 py-5 sm:py-10 rounded-xl sm:rounded-2xl relative overflow-hidden" data-id="element-320">
            <div className="absolute top-0 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-transparent via-primary to-transparent" data-id="element-321"></div>

            <div className="flex items-center justify-center gap-2 sm:gap-3 mb-1.5 sm:mb-4" data-id="element-322">
              <span className="text-text-sec line-through text-sm sm:text-2xl font-medium" data-id="element-323">
                € 250
              </span>
              <span className="bg-cta-green/20 text-cta-green font-black text-[10px] sm:text-sm px-2 py-0.5 sm:px-3 sm:py-1 rounded-full" data-id="element-324">
                {Math.round(100 - totalPrice / 250 * 100)}% OFF
              </span>
            </div>

            <div className="font-black text-5xl sm:text-8xl tracking-tighter transition-all leading-none text-[#FFFFFF]" data-id="element-325">
              € {totalPriceFormatted}
            </div>

            <div className="text-text-sec text-[11px] sm:text-base font-medium mt-2 sm:mt-3 flex items-center justify-center gap-2" data-id="element-326">
              <span data-id="element-327">💳 Pagamento unico</span>
              <span data-id="element-328">•</span>
              <span data-id="element-329">⚡ Accesso immediato</span>
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-secondary font-bold text-[10px] sm:text-sm bg-secondary/10 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-secondary/20 animate-pulse-composited mx-auto mb-4 sm:mb-6" data-id="element-330">
            ⏰ Prezzo speciale di lancio — salirà a breve
          </span>

          {/* ORDER BUMPS SECTION */}
          <div className="mb-4 sm:mb-6" data-id="element-331"></div>

          {/* CTA Button */}
          <a href={checkoutUrl} onClick={firePixel} style={{
          backgroundColor: '#22C55E',
          color: '#FFFFFF',
          boxShadow: '0 0 12px rgba(34,197,94,0.25), 0 6px 18px rgba(0,0,0,0.25)'
        }} className="btn-primary-pulse block w-full text-center font-black text-lg sm:text-3xl py-5 sm:py-8 rounded-2xl border-2 border-white/30 mb-4 sm:mb-6 tracking-tight uppercase transition-transform hover:scale-[1.02] active:scale-[0.99]" data-id="element-332">
            <span className="hidden sm:inline" data-id="element-333">{ctaCopy.desktop}</span>
            <span className="sm:hidden" data-id="element-334">{ctaCopy.mobile}</span>
          </a>

          {/* TRUST & SECURITY BADGES */}
          <div className="mt-6 sm:mt-8 pt-5 sm:pt-7 border-t border-white/10" data-id="element-335">
            {/* Trust pillars */}
            <div className="grid grid-cols-3 gap-2 sm:gap-4 mb-5 sm:mb-6" data-id="element-336">
              <div className="flex flex-col items-center text-center gap-1.5 sm:gap-2 bg-bg-dark/40 border border-white/10 rounded-xl px-2 py-3 sm:px-4 sm:py-4" data-id="element-337">
                <span className="text-2xl sm:text-3xl" aria-hidden="true" data-id="element-338">
                  🔒
                </span>
                <p className="text-white font-black text-[10px] sm:text-sm leading-tight" data-id="element-339">
                  Pagamento Sicuro
                </p>
                <p className="text-text-sec text-[9px] sm:text-xs leading-snug hidden sm:block" data-id="element-340">
                  Crittografia SSL 256-bit
                </p>
              </div>
              <div className="flex flex-col items-center text-center gap-1.5 sm:gap-2 bg-bg-dark/40 border border-white/10 rounded-xl px-2 py-3 sm:px-4 sm:py-4" data-id="element-341">
                <span className="text-2xl sm:text-3xl" aria-hidden="true" data-id="element-342">
                  🛡️
                </span>
                <p className="text-white font-black text-[10px] sm:text-sm leading-tight" data-id="element-343">
                  Garanzia 7 Giorni
                </p>
                <p className="text-text-sec text-[9px] sm:text-xs leading-snug hidden sm:block" data-id="element-344">
                  Soddisfatti o rimborsati
                </p>
              </div>
              <div className="flex flex-col items-center text-center gap-1.5 sm:gap-2 bg-bg-dark/40 border border-white/10 rounded-xl px-2 py-3 sm:px-4 sm:py-4" data-id="element-345">
                <span className="text-2xl sm:text-3xl" aria-hidden="true" data-id="element-346">
                  ✅
                </span>
                <p className="text-white font-black text-[10px] sm:text-sm leading-tight" data-id="element-347">
                  Acquisto Verificato
                </p>
                <p className="text-text-sec text-[9px] sm:text-xs leading-snug hidden sm:block" data-id="element-348">
                  +800 insegnanti soddisfatte
                </p>
              </div>
            </div>

            {/* Payment methods */}
            <p className="text-center text-text-sec text-[9px] sm:text-[11px] font-bold uppercase tracking-[0.15em] mb-2.5 sm:mb-3" data-id="element-349">
              Pagamenti accettati
            </p>
            <div className="flex items-center justify-center gap-2 sm:gap-3 flex-wrap" data-id="element-350">
              {[{
              label: 'VISA',
              color: '#1A1F71'
            }, {
              label: 'Mastercard',
              color: '#EB001B'
            }, {
              label: 'AMEX',
              color: '#2E77BB'
            }, {
              label: 'PayPal',
              color: '#003087'
            }, {
              label: 'Apple Pay',
              color: '#000000'
            }, {
              label: 'Google Pay',
              color: '#4285F4'
            }].map(p => <span key={p.label} className="inline-flex items-center justify-center bg-white text-[10px] sm:text-xs font-black px-2.5 py-1.5 sm:px-3 sm:py-2 rounded-md shadow-sm border border-black/5" style={{
              color: p.color
            }} data-id="element-351">
                  {p.label}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}